<template>
  <el-container class="con-wrap">
    <el-aside class="left-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="用户" name="user">
          <div class="selectBox">
            <el-input
              class="selectInput"
              v-model="udeptName"
              @click.native="clickInput"
              readonly
            ></el-input>
            <div class="deptTree" :class="{ active: show == true }">
              <div class="custom-tree-container">
                <div class="block">
                  <el-tree
                    :data="udeptTreeData"
                    node-key="id"
                    @node-click="getUserList"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                  >
                    <span
                      class="custom-tree-node is-show"
                      slot-scope="{ node }"
                    >
                      <span>{{ node.label }}</span>
                    </span>
                  </el-tree>
                </div>
              </div>
            </div>
          </div>
          <div>
            <ul class="user-role-list">
              <li
                v-for="item in userList"
                class="is-show user-list-con"
                :class="{ active: flag == item.userId }"
                :key="item.userId"
                @click="userClick(item)"
              >
                <span class="userName">{{
                  item.fullName + "(" + item.username + ")"
                }}</span>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="部门" name="dept">
          <div class="custom-tree-container">
            <div class="dept">
              <el-tree
                :data="deptTreeData"
                node-key="id"
                @node-click="deptClick"
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
              >
                <span class="custom-tree-node is-show" slot-scope="{ node }">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="角色" name="role">
          <div>
            <ul class="user-role-list">
              <li
                v-for="item in roleList"
                class="is-show role-list-con"
                :class="{ active: roleFlag == item.roleId }"
                :key="item.roleId"
                @click="roleClick(item)"
              >
                <div class="roleName" :title="item.roleName">
                  {{ item.roleName }}
                </div>
              </li>
            </ul>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-aside>
    <el-container style="overflow-y:auto">
      <el-tabs v-model="activePowerName" @tab-click="handleClick">
        <el-tab-pane label="功能权限" name="functionPower">
          <authority-tree
            :authotityTitle="authotityTitle"
            :authorityData="authorityData"
            :keyArr="keyArr"
            @clickAuthority="authority"
          ></authority-tree>
        </el-tab-pane>
        <el-tab-pane label="数据权限" name="dataPower">
          <authority-tree
            :authotityTitle="authotityTitle"
            :authorityData="authorityData"
            :keyArr="keyArr"
            @clickAuthority="authority"
          ></authority-tree>
        </el-tab-pane>
        <el-tab-pane label="区域权限" name="areaPower">
          <authority-tree
            :authotityTitle="authotityTitle"
            :authorityData="authorityData"
            :keyArr="keyArr"
            @clickAuthority="authority"
          ></authority-tree>
        </el-tab-pane>
      </el-tabs>
    </el-container>
  </el-container>
</template>
<script>
import AuthorityTree from "../../../components/AuthorityTree.vue"
export default {
  components: {
    AuthorityTree,
  },
  data() {
    return {
      activeName: "user",
      activePowerName: "functionPower",
      udeptName: "",
      udeptId: "",
      udeptTreeData: [],
      show: false,
      flag: -1,
      roleFlag: -1,
      userList: [],
      deptId: "",
      deptTreeData: [],
      roleList: [],
      currentFlag: 1,
      type: 1,
      currentId: "",
      authorityData: [],
      keyArr: [],
      authotityTitle: "",
    }
  },
  created() {
    this.getDeptTree()
  },
  watch: {
    // 根据名称筛选部门树
    // udeptName (val) {
    //   this.$refs.deptTreeData.filter(val);
    // },
    // 默认点击Tree第一个节点
    udeptTreeData(val) {
      if (val) {
        this.show = true
        this.$nextTick(() => {
          document.querySelector(".block .el-tree-node__content").click()
        })
      }
    },
    userList(val) {
      if (val[0]) {
        this.$nextTick(() => {
          document.querySelector(".user-list-con").click()
        })
      }
    },
    deptTreeData(val) {
      if (val) {
        this.show = true
        this.$nextTick(() => {
          document.querySelector(".dept .el-tree-node__content").click()
        })
      }
    },
    roleList(val) {
      if (val[0]) {
        this.$nextTick(() => {
          document.querySelector(".role-list-con").click()
        })
      }
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab.name, event)
      if (tab.name == "user") {
        this.currentFlag = 1
        this.show = false
        this.activePowerName = "functionPower"
        this.type = 1
        this.getDeptTree()
      } else if (tab.name == "dept") {
        this.currentFlag = 2
        this.activePowerName = "functionPower"
        this.type = 1
        this.getDeptList()
      } else if (tab.name == "role") {
        this.currentFlag = 3
        this.activePowerName = "functionPower"
        this.type = 1
        this.getRoleList()
      } else if (tab.name == "functionPower") {
        this.keyArr = []
        this.type = 1
        this.authotityTitle = "所有模块"
        this.getAuthority(this.currentId, this.type)
      } else if (tab.name == "dataPower") {
        this.keyArr = []
        this.type = 2
        this.authotityTitle = "所有部门"
        this.getAuthority(this.currentId, this.type)
      } else if (tab.name == "areaPower") {
        this.keyArr = []
        this.type = 3
        this.authotityTitle = "所有区域"
        this.getAuthority(this.currentId, this.type)
      }
    },
    clickInput() {
      this.show = !this.show
    },
    async getDeptTree() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/dept/list")
      if (res.code == 1) {
        _this.udeptTreeData = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async getUserList(data) {
      let _this = this
      _this.udeptName = data.label
      _this.show = !_this.show
      let parm = {
        deptId: data.id,
        range: 1,
      }
      let { data: res } = await _this.$axios.get("/api/sys/user/options", {
        params: parm,
      })
      if (res.code == 1) {
        // 部门中无用户时重置子组件相关数据
        if (res.data.length == 0) {
          _this.authorityData = []
          _this.currentId = ""
        }
        _this.userList = res.data
      } else {
        //获取用户失败重置子组件相关数据
        _this.authorityData = []
        _this.currentId = ""
        _this.$message.warning(res.msg)
      }
    },
    async getDeptList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/dept/list")
      if (res.code == 1) {
        if (res.data.length == 0) {
          _this.authorityData = []
          _this.currentId = ""
        }
        _this.deptTreeData = res.data
      } else {
        _this.authorityData = []
        _this.currentId = ""
        _this.$message.warning(res.msg)
      }
    },
    async getRoleList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/role/list")
      if (res.code == 1) {
        if (res.data.length == 0) {
          _this.authorityData = []
          _this.currentId = ""
        }
        _this.roleList = res.data
      } else {
        _this.authorityData = []
        _this.currentId = ""
        _this.$message.warning(res.msg)
      }
    },
    userClick(item) {
      this.flag = item.userId
      this.currentId = item.userId
      this.getAuthority(this.currentId, this.type)
    },
    deptClick(deptDatas) {
      this.currentId = deptDatas.id
      this.getAuthority(this.currentId, this.type)
    },
    roleClick(item) {
      this.roleFlag = item.roleId
      this.currentId = item.roleId
      this.getAuthority(this.currentId, this.type)
    },
    async getAuthority(id, type) {
      let _this = this
      let data = []
      if (this.currentFlag == 1) {
        if (id == "") {
          return
        }
        let parm = {
          userId: id,
          type: type,
        }
        data = await _this.$axios.get("/api/sys/user/authority/list", {
          params: parm,
        })
      } else if (this.currentFlag == 2) {
        if (id == "") {
          return
        }
        let parm = {
          deptId: id,
          type: type,
        }
        data = await _this.$axios.get("/api/sys/dept/authority/list", {
          params: parm,
        })
      } else if (this.currentFlag == 3) {
        if (id == "") {
          return
        }
        let parm = {
          roleId: id,
          type: type,
        }
        data = await _this.$axios.get("/api/sys/role/authority/list", {
          params: parm,
        })
      }
      let res = data.data
      if (res.code == 1) {
        this.authorityData = res.data
        this.keyArr = []
      } else {
        this.keyArr = []
        _this.$message.warning(res.msg)
      }
    },
    async authority(authority, key) {
      let _this = this
      let data = []
      let parm = {
        authorizationList: [authority],
        id: _this.currentId,
        type: _this.type,
      }
      if (this.currentFlag == 1) {
        data = await _this.$axios.post("/api/sys/user/authority", parm)
      } else if (this.currentFlag == 2) {
        data = await _this.$axios.post("/api/sys/dept/authority", parm)
      } else if (this.currentFlag == 3) {
        data = await _this.$axios.post("/api/sys/role/authority", parm)
      }
      let res = data.data
      if (res.code == 1) {
        this.keyArr = key
        _this.authorityData = res.data
        //页面只做物理修改不刷新数据
        //_this.getAuthority(_this.currentId, _this.type)
      } else {
        _this.$message.warning(res.msg)
        _this.getAuthority(_this.currentId, _this.type)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap /deep/ .el-tabs__item {
  width: 78px;
  padding: 0 5px !important;
  text-align: center;
  box-sizing: content-box;
}
.con-wrap /deep/ .el-container {
  background-color: #fff;
}
.con-wrap /deep/ .el-tabs {
  width: 100%;
}
.con-wrap .left-wrap /deep/ .el-tabs .el-tabs__content {
  padding: 0 10px;
  overflow: visible;
}
.con-wrap /deep/ .el-tabs__nav {
  margin-left: 18px;
}
.selectBox {
  width: 100%;
  position: relative;
}
.selectBox .selectInput /deep/ .el-input__inner {
  cursor: pointer !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.deptTree {
  width: 100%;
  height: 540px;
  overflow: auto;
  margin-left: 18px;
  position: absolute;
  top: 40px;
  left: -18px;
  font-size: 14px;
  display: none;
  z-index: 2;
}
.deptTree.active {
  display: block;
}
.user-role-list {
  position: relative;
  margin-top: 12px;
  color: #606266;
  background: #fff;
  cursor: default;
}
.roleName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}
.user-role-list .is-show:hover {
  background: #f5f7fa;
}
.user-role-list .active {
  background: #ddf0fe !important;
  color: #0094ff;
}
.user-role-list .is-show {
  font-size: 14px;
  padding: 0 8px 0 10px;
  line-height: 28px;
  cursor: pointer;
}
</style>
